import Vue from 'vue';
import { defineStore } from 'pinia';
import _ from 'lodash';

import KnowledgeEntryApi from '@/extensions/knowledge-base/store/api/knowledgeEntry';

export const useKnowledgeEntryStore = defineStore('knowledgeEntry', {
    state: () => ({
        loading: true,
        knowledgeSourceId: null,
        knowledgeEntriesPaginated: {
            variables: {
                order: 'created_at',
                direction: 'desc',
                paginationSizes: [25, 50, 100]
            },
            filters: {},
            pageInfo: {
                total: 0,
                perPage: 25,
                currentPage: 1,
                lastPage: 0
            },
            allColumns: [],
            activeColumns: [],
            showFilters: false,
            defaultSort: null,
            link: {},
            items: []
        }
    }),

    actions: {
        setKnowledgeSourceId(id) {
            this.knowledgeSourceId = id;
        },

        addPaginatedEntriesToState(data) {
            this.knowledgeEntriesPaginated.items = data.items;
            this.knowledgeEntriesPaginated.pageInfo = _.cloneDeep(data.pageInfo);
            this.knowledgeEntriesPaginated.allColumns = _.cloneDeep(data.config.allColumns);
            this.knowledgeEntriesPaginated.link = _.cloneDeep(data.config.link);
            this.knowledgeEntriesPaginated.showFilters = _.get(data.config, 'showFilters') || false;
            this.knowledgeEntriesPaginated.defaultSort = _.get(data.config, 'defaultSort') || null;
        },

        defineActiveColumns(activeColumnKeys) {
            const activeColumns = [];
            _.each(this.knowledgeEntriesPaginated.allColumns, column => {
                const allowed = _.find(activeColumnKeys, value => column.key === value);
                if (allowed) activeColumns.push(column);
            });

            if (activeColumns.length) {
                this.knowledgeEntriesPaginated.activeColumns = activeColumns;
            }
        },

        defineItemsPerPage(perPage) {
            this.knowledgeEntriesPaginated.pageInfo.perPage = perPage;
        },

        defineCurrentPage(currentPage) {
            this.knowledgeEntriesPaginated.pageInfo.currentPage = currentPage;
        },

        defineFilterValue({ key, value }) {
            if (value.match === '' && value.like === '' && value.from === '' && value.to === '' && value.in.length === 0) {
                Vue.delete(this.knowledgeEntriesPaginated.filters, key);
            } else {
                Vue.set(this.knowledgeEntriesPaginated.filters, key, value);
            }
        },

        defineSorting({ key, value }) {
            this.knowledgeEntriesPaginated.variables.order = key;
            this.knowledgeEntriesPaginated.variables.direction = value;
        },

        defineFilterVisibility(value) {
            this.knowledgeEntriesPaginated.showFilters = value;
        },

        updateLoading(value) {
            this.loading = value;
        },

        fetchKnowledgeEntriesPaginated() {
            return KnowledgeEntryApi.fetchKnowledgeEntriesPaginated(this.knowledgeEntriesPaginated, this.knowledgeSourceId).then(data => {
                this.addPaginatedEntriesToState(data);

                const activeColumnKeys = _.map(data.config.activeColumnKeys, 'key');
                this.defineActiveColumns(activeColumnKeys);
            });
        },

        createKnowledgeEntry({ title, body }) {
            return KnowledgeEntryApi.createKnowledgeEntry({
                knowledgeSourceId: this.knowledgeSourceId,
                title,
                body
            });
        },

        updateKnowledgeEntry({ id, title, body }) {
            return KnowledgeEntryApi.updateKnowledgeEntry({ id, title, body });
        },

        deleteKnowledgeEntry(id) {
            return KnowledgeEntryApi.deleteKnowledgeEntry(id);
        }
    }
});
